"use client";

import { Fragment } from "react";
import { useRef, useState, useEffect } from "react";
import { isEmpty } from "lodash";
import { useQuery } from "@/lib/api/hooks";
import { Hero } from "@/components/hero";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faSpinnerThird,
  faCircleExclamation,
} from "@fortawesome/pro-thin-svg-icons";
import { Binders } from "@/components/binders";
import { SearchBox } from "./search-box";
import { SortLayoutBox } from "./sort-layout-box";

const searchTypes = [
  { value: "0", label: "Public Binders" },
  { value: "1", label: "Author" },
  //   { value: '2', label: 'My Binders' },
  //   { value: '3', label: 'Educational Category' },
  //   { value: '4', label: 'Shelves' },
  { value: "5", label: "Binder ID" },
  { value: "6", label: "Name" },
  { value: "7", label: "Description" },
  { value: "8", label: "Tags" },
];

const sortTypes = [
  { value: "featured", label: "Featured" },
  { value: "recent", label: "Most Recent" },
  { value: "viewed", label: "Most Viewed" },
  { value: "useful", label: "Most Useful" },
];

function Loader() {
  return (
    <div className="flex justify-center items-center min-h-[450px] my-5 px-5 py-20 bg-gray-50">
      <div className="text-center md:flex items-center max-w-[500px]">
        <FontAwesomeIcon className="text-4xl mr-5" icon={faSpinnerThird} spin />
        <p className="text-xl">Loading</p>
      </div>
    </div>
  );
}

function NoResults() {
  return (
    <div className="flex justify-center items-center min-h-[450px] my-5 px-5 py-20 bg-gray-50">
      <div className="text-center md:flex items-center max-w-[500px]">
        <FontAwesomeIcon className="text-4xl mr-5" icon={faCircleExclamation} />
        <p className="text-lg">
          We couldn&rsquo;t find any results matching your parameters. Please
          try another search query.
        </p>
      </div>
    </div>
  );
}

export function PageTemplate({ heroSection, searchParams }) {
  const resultsRef = useRef(null);

  const [layout, setLayout] = useState({ variant: "grid", size: "sm" });
  const [sort, setSort] = useState(sortTypes[0].value);
  const [type, setType] = useState(searchTypes[0].value);
  const [terms, setTerms] = useState("");
  const endpoint = isEmpty(terms) ? "featured" : "search";

  const { data, error, loading } = useQuery([
    `/shelf/${endpoint}`,
    {
      type,
      sort,
      terms,
    },
  ]);

  useEffect(() => {
    setTerms(searchParams.keywords);
  }, [searchParams]);

  const handleSearch = (data) => {
    setType(data.type);
    setTerms(data.terms);
    scrollToResults();
  };

  const scrollToResults = () => {
    if (resultsRef.current) {
      resultsRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  };

  return (
    <Fragment>
      {heroSection && (
        <Hero
          backgroundVideoUrl={heroSection.backgroundVideoUrl}
          backgroundImage={heroSection.backgroundImage}
          title={heroSection.title}
          subtitle={heroSection.subtitle}
          buttons={heroSection.buttons}
          variant={heroSection.variant}
          overlay={heroSection.overlay}
          size="sm"
        >
          <SearchBox
            className="mt-10"
            defaultValue={{ terms, type }}
            onSubmit={handleSearch}
          />
        </Hero>
      )}
      <div ref={resultsRef} className="px-5">
        <div className="max-w-6xl mx-auto">
          {loading && <Loader />}

          {!loading && isEmpty(data?.binders) && <NoResults />}

          {!loading && !isEmpty(data?.binders) && (
            <div className="my-5">
              <SortLayoutBox
                sort={sort}
                onSort={(value) => setSort(value)}
                layout={layout}
                onLayout={(value) => setLayout(value)}
              />

              <Binders
                className="mt-24 mb-32"
                binders={data.binders}
                // maxCount={maxCount}
                layout={layout.variant}
                size={layout.size}
              />
            </div>
          )}
        </div>
      </div>
    </Fragment>
  );
}
